export default [
  {
    path: 'uz-asbo',
    name: 'uz-asbo',
    component: () => import('@/views/pages/uz-asbo/UzAsbo.vue'),
    meta: {
      pageTitle: 'UzAsbo',
      breadcrumb: [
        {
          text: 'UzAsbo',
          active: true,
        },
      ],
      resource: 'UzAsbo',
      action: 'read',
    },
  },
  {
    path: 'uz-asbo/monthly',
    name: 'uz-asbo-monthly',
    component: () => import('@/views/pages/uz-asbo/Monthly.vue'),
    meta: {
      pageTitle: 'Monthly summary',
      breadcrumb: [
        {
          to: { name: 'uz-asbo' },
          text: 'UzAsbo',
          active: false,
        },
        {
          text: 'Monthly summary',
          active: true,
        },
      ],
      // Faqat Innovatsiya uchun: tashkilot rollarida bu resurs yo'q
      resource: 'UzAsboMonthly',
      action: 'read',
    },
  },
  {
    path: 'uz-asbo/:id',
    name: 'uz-asbo-view',
    component: () => import('@/views/pages/uz-asbo/View.vue'),
    meta: {
      pageTitle: 'UzAsbo',
      breadcrumb: [
        {
          to: { name: 'uz-asbo' },
          text: 'UzAsbo',
          active: false,
        },
        {
          text: 'List',
          active: true,
        },
      ],
      resource: 'UzAsbo',
      action: 'read',
    },
  },
]
